import {
   VisitDocumentTemplateHtmlContent,
   VisitDocumentTemplateRealDataHtmlQuery,
} from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { useDraftCqrsFind } from '@dreryk/react-draft';

import { DocumentTemplateFormBean } from '~libs.desktop.shared.document-template';

import { documentTemplateDraftSchema, getDocumentTemplateDraftToken } from './documentTemplate.draft';
import { translationKeys } from './translations';

type DocumentTemplateFormRenderProps = {
   documentTemplate: VisitDocumentTemplateHtmlContent;
   documentTemplateDraft: DocumentTemplateFormBean | null;
};

type DocumentTemplateFormLoaderProps = {
   readonly visitId: number;
   readonly printTemplateId: number;
   readonly children: (renderProps: DocumentTemplateFormRenderProps) => JSX.Element;
};

export const DocumentTemplateFormLoader = (props: DocumentTemplateFormLoaderProps): JSX.Element => {
   const {
      data: documentTemplate,
      loading: documentTemplateLoading,
      error: documentTemplateError,
   } = useCqrsGet<VisitDocumentTemplateHtmlContent>(() => {
      const query = new VisitDocumentTemplateRealDataHtmlQuery();
      query.visitId = props.visitId;
      query.printTemplateId = props.printTemplateId;
      return query;
   });

   const {
      data: documentTemplateDraft,
      loading: documentTemplateDraftLoading,
      error: documentTemplateDraftErorr,
   } = useDraftCqrsFind(
      {
         token: getDocumentTemplateDraftToken(props.visitId, props.printTemplateId),
      },
      documentTemplateDraftSchema
   );

   if (documentTemplateLoading || documentTemplateDraftLoading) {
      return <LoaderSpinner />;
   }

   if (documentTemplateError || documentTemplateDraftErorr) {
      return (
         <Message
            testId={'documentTemplateFetchError'}
            type={MessageType.NEGATIVE}
            label={translationKeys.documentTemplateFetchError}
            displayIndicator
         />
      );
   }

   return props.children({
      documentTemplate: documentTemplate,
      documentTemplateDraft: documentTemplateDraft?.contents ?? null,
   });
};
